import React from 'react';

                  const RobotIcon = ({scale, color="white", bgColor="black", isHappy = false, isAnimated = false}) => (
                    <svg
                      width={scale}
                      height={scale}
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {/* Circle background - no animation */}
                      <circle cx="24" cy="24" r="24" fill={bgColor}/>

                      {/* Robot elements grouped together with animation */}
                      <g
                        style={{
                          transformOrigin: 'center',
                          animation: isAnimated ? 'robotBounce 1s infinite' : 'none',
                          transition: 'transform 0.3s ease-in-out',
                        }}
                      >
                        {/* Add keyframes to document head */}
                        {isAnimated && (
                          <style>
                            {`
                              @keyframes robotBounce {
                                0%, 20%, 50%, 80%, 100% {
                                  transform: translateY(0);
                                }
                                40% {
                                  transform: translateY(-2px);
                                }
                                60% {
                                  transform: translateY(-1px);
                                }
                              }
                            `}
                          </style>
                        )}

                        {/* Robot face and body */}
                        <path
                          d="M27.382 14.391h-6.765a6.225 6.225 0 0 0-6.227 6.226v6.765a6.226 6.226 0 0 0 6.227 6.228h6.765a6.225 6.225 0 0 0 6.228-6.228v-6.765a6.225 6.225 0 0 0-6.228-6.227v.001z"
                          stroke={color}
                          strokeWidth="2"/>

                        {/* Robot arms */}
                        <path
                          d="M33.508 28.485h2.023a1.28 1.28 0 0 0 1.282-1.281v-6.407a1.281 1.281 0 0 0-1.282-1.28h-2.025m-19.012 8.968h-2.025a1.282 1.282 0 0 1-1.281-1.281v-6.407a1.281 1.281 0 0 1 1.28-1.28h2.026"
                          stroke={color}
                          strokeWidth="2"/>

                        {/* Antenna */}
                        <path
                          d="M12.456 19.516v-5.125m23.075 5.125-.012-5.125"
                          stroke={color}
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"/>

                        {/* Eyes - Angel eyes when not happy, normal when happy */}
                        {!isHappy ? (
                          // Angel eyes (straight lines above normal position)
                          <path
                            d="M18.85 21.5h2.559m5.128 0h2.562"
                            stroke={color}
                            strokeWidth="2"
                            strokeLinecap="round"/>
                        ) : (
                          // Happy eyes (dots)
                          <path
                            d="M18.85 22.72l1.279-1.282 1.28 1.282m5.128 0 1.282-1.282 1.28 1.282"
                            stroke={color}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"/>
                        )}

                        {/* Mouth - Straight when not happy, smile when happy */}
                        {!isHappy ? (
                          // Straight face
                          <path
                            d="M21.437 26.5h5.125"
                            stroke={color}
                            strokeWidth="2"
                            strokeLinecap="round"/>
                        ) : (
                          // Smile
                          <path
                            d="M21.437 28.046a3.638 3.638 0 0 0 5.125 0"
                            stroke={color}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"/>
                        )}
                      </g>
                    </svg>
                  );

                  export default RobotIcon;